/**
 * Payment API Error Codes
 * Maps error codes from backend to descriptive constants
 */

export enum PaymentErrorCodeEnum {
  INSUFFICIENT_FUNDS = '4017',
  COP_VALIDATION_FAILED = '4205',
  // Client-side error when wallet balance refresh fails before submission
  WALLET_BALANCE_REFRESH_FAILED = 'WALLET_BALANCE_REFRESH_FAILED'
}

export const getErrorMessage = (code: string | undefined, accountName?: string): string => {
  switch (code) {
    case PaymentErrorCodeEnum.INSUFFICIENT_FUNDS:
      return accountName
        ? `Your payment has failed due to insufficient funds in ${accountName}. Please transfer funds and try again.`
        : 'Your payment has failed due to insufficient funds. Please transfer funds and try again.';

    case PaymentErrorCodeEnum.WALLET_BALANCE_REFRESH_FAILED:
      return 'Unable to verify wallet balance. Please try again.';

    default:
      return 'Your payment has failed. Please try again.';
  }
};
